import { render, staticRenderFns } from "./Pill.vue?vue&type=template&id=345c444e&scoped=true&"
var script = {}
import style0 from "./Pill.vue?vue&type=style&index=0&id=345c444e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345c444e",
  null
  
)

export default component.exports